import * as React from "react";
type Props = {
  className?: string,
};
function SvgPencil({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="utility-pencil"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 13.9969L13.5 4.4995C13.5 4.4995 16 1.9943 19 4.9969C22 7.9995 19.5 10.4995 19.5 10.4995L10 19.9969H4V13.9969ZM16.807 10.3637L9.17173 17.9969H6V14.8255L13.6355 7.19211L16.807 10.3637Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgPencil;
